import React, { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'grab-ui';
import I18n from 'i18n-js';
import scribeTrack from 'scribe/scribe-track';
import instrumentationDuck from 'ducks/instrumentation-duck';
import arrowLeft from 'public/images/arrow-left.svg';

import TrackingTextbox from '../tracking-textbox/tracking-texbox';
import styles from './tracking-banner.less';

const TrackingBanner = () => {
  const navigate = useNavigate();
  const { orderId, trackingPageType, trackingSource, isExpired } = useSelector(
    instrumentationDuck.selectors.instrumentation,
  );

  const goBack = useCallback(
    () => {
      scribeTrack.expressTracking.back({
        orderIdDisplayed: orderId,
        trackingPageType,
        trackingSource,
        isInApp: false,
        isTrackingLinkExpired: isExpired,
      });

      navigate(-1);
    },

    [orderId, trackingPageType, trackingSource, isExpired],
  );

  return (
    <Fragment>
      <div className={styles.titleContainer}>
        <Button
          className={styles.backButton}
          onClick={goBack}
          aria-label="go back"
        >
          <img className={styles.backArrow} src={arrowLeft} alt="back" />
        </Button>
        <p className={styles.title}>
          {I18n.t('orderSearch.trackingBanner.trackingLabelText')}
        </p>
      </div>

      <div className={styles.trackingBoxContainer}>
        <TrackingTextbox />
      </div>
    </Fragment>
  );
};

export default TrackingBanner;
